import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/24/thumb-landscape.jpg"

const Post24 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">SAINT LAURENT／ベイビーカバス／26 x19 x12cm</span>  
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>フランスを代表するラグジュアリーブランド「サンローラン（Saint Laurent）」。<br></br>1961年にオートクチュールメゾンとして設立されて以来、時代を代表する数々の革命的なアイテムを産み出し、世界的ブランドへと躍進を遂げました。そんな歴史から「モードの帝王」と称されるサンローランのバッグは、洗練されたクールなデザインが特徴的です。今回はラクサスで人気のサンローランのブランドバッグ10選をご紹介します♪</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>モノグラム</h2>
          <p>ロゴの金具がアイコニックな「モノグラム」はサンローランの定番バッグ。毎日使っても飽きないシンプルなデザインは、ヘビーローテーションバッグとしてデイリーに活躍してくれそう。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/24/1.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/2.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">SAINT LAURENT／カバス スモール／28 x21 x13cm</span>                
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/3.jpg" alt="" />
              <span className="text-center">SAINT LAURENT／ベイビーカバス／25 x19 x12cm</span>  
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/4.jpg" alt="" />
              <span className="text-center">SAINT LAURENT／ベイビーカバス／26 x18 x10cm</span>  
          </figure>
        </div>
        <div className="text-max-width">
          <h2>サックドジュール</h2>
          <p>ミニマルなデザインと、高い収納力で人気を誇る「サックドジュール」。ショルダーバッグとして使ってもカジュアルになりすぎない気品溢れるデザインはシーンを問わず活躍してくれること間違いなし。</p>          
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/24/5.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/6.jpg" alt="" />
          </figure>
        </div>     
        <span className="text-center">SAINT LAURENT／サックドジュール／32 x24 x15cm</span>               
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/7.jpg" alt="" />
              <span className="text-center">SAINT LAURENT／サックドジュール／30 x24 x15cm</span>    
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/8.jpg" alt="" />
              <span className="text-center">SAINT LAURENT／サックドジュール／32 x25 x14cm</span>    
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ダッフル</h2>
          <p>2013年に発表されて以来、瞬く間に人気に火がつき、数々の雑誌に掲載され、国内外のセレブから愛用されている「ダッフル」。特に小さめのサイズ感が可愛らしい「ベイビーダッフル」は、ラクサスでも人気の高いモデルです。</p>
        </div>
        <div className="img-two-cloumn">
        <figure className="img-small">
              <StaticImage src="../../images/posts/24/9.jpg" alt="" />
            </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/10.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">SAINT LAURENT／ベイビーダッフル／22 x14 x10cm</span>   
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/11.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/12.jpg" alt="" />
          </figure>
        </div>     
        <span className="text-center">SAINT LAURENT／ベイビーダッフル／22 x15 x10cm</span>      
        <div className="text-max-width">
          <h2>モノグラムショルダー</h2>
          <p>「モノグラムショルダー」はコロンとした丸みのあるフォルムが可愛らしく、若い世代の女性に人気のモデル。バッグは小ぶりですが、大きめのフリンジがデザインのアクセントになっているので、寂しい印象にならずこなれた印象を作ってくれます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/24/13.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/14.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">SAINT LAURENT／ブロガーバッグ／13 x11 x5cm</span>                   
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/15.jpg" alt="" />
              <span className="text-center">SAINT LAURENT／ブロガーバッグ／14 x11 x5cm</span>    
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/16.jpg" alt="" />
              <span className="text-center">SAINT LAURENT／ショルダーバッグ／13 x11 x4cm</span>    
          </figure>
        </div>    
        <div className="text-max-width">
          <h2>ミューズ</h2>
          <p>「ミューズ」はバッグ中央にあしらわれたY字のステッチに高級感のあるゴールドの南京錠が付いたスタイリッシュなデザインが人気。口が大きく開く半円型なので物の出し入れがしやすいのも嬉しいポイント♪</p>
        </div>      
        <div className="img-two-cloumn">
          <figure className="img-small">
                <StaticImage src="../../images/posts/24/17.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/18.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">SAINT LAURENT／ミューズ／45 x33 x15cm</span>     
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/19.jpg" alt="" />
              <span className="text-center">SAINT LAURENT／ミューズ／42 x26 x13cm</span>  
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/20.jpg" alt="" />
              <span className="text-center">SAINT LAURENT／ミューズ／37 x22 x12cm</span>  
          </figure>
        </div>        
        <Link to="https://laxus.co/app/pc/bags/ysl" className="view-all-button">
          サンローランのバッグを見る
        </Link>        
        <div className="text-max-width">
          <h2>ケイト タッセルチェーンウォレット</h2>
          <p>「ケイト タッセルチェーンウォレット」は、艶のあるレザーとゴールドのフリンジが高級感溢れるデザイン。ナイトアウトにもぴったりな大人の色気を底上げしてくれるバッグです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/21.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/22.jpg" alt="" />
          </figure>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/23.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/24.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">SAINT LAURENT／ケイト／24 x16 x5cm</span>            
        <div className="text-max-width">
          <h2>トートバッグ</h2>
          <p>サンローランの「トートバッグ」は、無駄を省いたシンプルなデザインがビジネスシーンにぴったり♪荷物が多いときは、サブバッグとしても愛用できる形なのでヘビーローテーション間違いなし。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/25.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/26.jpg" alt="" />
          </figure>
        </div>      
        <span className="text-center">SAINT LAURENT／トートバッグ／33 x39 x13cm</span>      
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/27.jpg" alt="" />
              <span className="text-center">SAINT LAURENT／カハラトート／37 x37 x1cm</span>      
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/28.jpg" alt="" />
              <span className="text-center">SAINT LAURENT／カハラトート／37 x37 x2cm</span>      
          </figure>
        </div>
        <div className="text-max-width">
          <h2>サントロペ</h2>
          <p>レザーを重ねたフリルスカートのようなデザインが美しい「サントロペ」。フリルというとフェミニンなイメージですが、上質なレザーを使うことで甘くなりすぎず、大人の女性が持つと上品でエレガントな印象になるバッグです♪</p>
        </div>
        <figure className="img-small">
            <StaticImage src="../../images/posts/24/29.jpg" alt="" />
            <span className="text-center">SAINT LAURENT／サントロペ／27 x24 x2.5cm</span>    
        </figure>       
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/24/30.jpg" alt="" />
            <span className="text-center">SAINT LAURENT／サントロペ／27 x24 x2.5cm</span>    
          </figure>            
          <figure className="img-small">
            <StaticImage src="../../images/posts/24/31.jpg" alt="" />
            <span className="text-center">SAINT LAURENT／サントロペ／28 x25 x3cm</span>    
          </figure>
        </div>
        <div className="text-max-width">
          <h2>バケットバッグ</h2>
          <p>「バケットバッグ」は上質なレザーを使ったシンプルなデザインがいつものコーデをワンランクアップさせてくれるアイテム。ハンドルと取り外し可能なショルダーストラップも付いているので、使い勝手も抜群♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/24/32.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/33.jpg" alt="" />
          </figure>
        </div>     
        <span className="text-center">SAINT LAURENT／バケットバッグ／14 x17 x11cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/24/34.jpg" alt="" />
            <span className="text-center">SAINT LAURENT／バケットバッグ／14 x17 x12cm</span>     
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/35.jpg" alt="" />
              <span className="text-center">SAINT LAURENT／エマニュアルバケット／14 x17 x11cm</span>     
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ミューズトゥ</h2>
          <p>バッグ両端にデザインされたベルトが特徴的な「ミューズトゥ」。あえてベルトのボタンを外してカジュアルに、締めればフォーマルにも対応できるかっちりとした印象に。用途に応じて色々な楽しみ方ができるバッグです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/36.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/37.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">SAINT LAURENT／ミューズトゥ／27 x19 x14cm</span>    
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/24/38.jpg" alt="" />
            <span className="text-center">SAINT LAURENT／ミューズトゥ／27 x18 x13cm</span>    
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/24/39.jpg" alt="" />
              <span className="text-center">SAINT LAURENT／ミューズトゥ／26 x16 x13cm</span>    
          </figure>
        </div>                               
        <div className="text-two-cloumn">
          <h2>モードで洗練された<br className="pc"></br>サンローランの魅力</h2>
          <p>洗練されたシンプルさとラグジュアリーな高級感が魅力のサンローランのバッグは持っているだけでワンランク上のオシャレを楽しめるブランド。ぜひオシャレの参考に♪</p>
        </div>                          
        <Link to="https://laxus.co/app/pc/bags/ysl" className="view-all-button">
          サンローランのバッグを見る
        </Link>                
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post24

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 24}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
